import { Box, Image } from '@mantine/core'

import type { ContentProps } from '@/layouts/DefaultLayout/components/Content/Content.types'

import classes from './Content.module.css'

export function Content({ children }: ContentProps) {
  return (
    <Box className={classes.content}>
      <Image
        alt="Rolan Wealth"
        className={classes.contentLogo}
        src="/logo.svg"
      />
      {children}
    </Box>
  )
}
